import React from 'react'
import { Flex, Heading } from '@workwhile/ui'

type SectionHeadingProps = {
  listingId?: number
}

export const SectionHeading = ({ listingId }: SectionHeadingProps) => {
  return (
    <Flex
      alignItems="center"
      gap={4}
      data-context-key="listing-id"
      data-context-value={listingId}
      data-context-label="Listing ID"
    >
      <Heading level={2} fontWeight="400">
        Listing Overview {listingId ? `(${listingId})` : ''}
      </Heading>
    </Flex>
  )
}
